import * as yup from "yup";
export const schema = yup
  .object({
    name: yup.string().trim().required('Name is required'),
    rss: yup.array(),
  })
  .required();